// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__ED2gM","row":"styles_row__39XPB"};